import Head from "next/head";
import {
  useStoryblokState,
  getStoryblokApi,
  StoryblokComponent,
} from "@storyblok/react";

export default function Page({ story: intialStory }) {
  const story = useStoryblokState(intialStory);

  return (
    <div>
      <Head>
        <title>{story ? `Welldoing - ${story.name}` : "Welldoing"}</title>
        <meta name="description" content={`Welldoing - ${story?.name}`} />
        <meta name="og:description" content={`Welldoing - ${story?.name}`} />
        <link rel="icon" href="/favicon.ico" />
        <link
          rel="canonical"
          href={`https://welldoing.org/${story.full_slug}`}
        />
      </Head>
      <div>
        <StoryblokComponent blok={story.content} />
      </div>
    </div>
  );
}

export async function getStaticProps({ params, draftMode }) {
  let slug = (await params.slug) ? params.slug.join("/") : "home";
  let sbParams = {
    version: draftMode ? "draft" : "published",
  };

  const storyblokApi = getStoryblokApi();
  try {
    const { data } = await storyblokApi.get(`cdn/stories/${slug}`, sbParams, {
      cache: draftMode ? "no-cache" : undefined,
      next: {
        revalidate: draftMode ? undefined : 3600,
      },
    });
    var story = data.story;
  } catch (e) {
    console.error(`Cannot retrieve evergreen ${slug}`);
    console.error(e);
    return {
      notFound: true,
    };
  }

  if (slug === "types-of-therapy") {
    try {
      const {
        data: { stories },
      } = await storyblokApi.get(`cdn/stories`, {
        starts_with: "types",
        sort_by: "name:asc",
        per_page: 100,
      });
      const filteredTypes = stories.filter(
        (story) => story.slug !== "types-of-therapy"
      );
      story.content.body[2].types = filteredTypes;
      const hasItems = [];
      filteredTypes.forEach((item) => {
        hasItems.push(item.name[0].toLowerCase());
      });
      story.content.body[2].letterHasItems = hasItems;
    } catch (error) {
      console.error(e);
    }
  }

  if (slug === "whats-worrying-you") {
    try {
      const {
        data: { stories },
      } = await storyblokApi.get(`cdn/stories`, {
        starts_with: "therapy",
        sort_by: "name:asc",
        per_page: 100,
      });
      const filteredWorries = stories.filter(
        (story) => story.slug !== "whats-worrying-you"
      );
      story.content.body[2].worries = filteredWorries;
      const hasItems = [];
      filteredWorries.forEach((item) => {
        hasItems.push(item.name[0].toLowerCase());
      });
      story.content.body[2].letterHasItems = hasItems;
    } catch (error) {
      console.error(e);
    }
  }

  return {
    props: {
      draftMode: draftMode || null,
      story: story ?? false,
      story_id: story?.id ?? false,
      slug,
    },
    revalidate: draftMode ? undefined : 3600,
  };
}

export async function getStaticPaths() {
  const storyblokApi = getStoryblokApi();
  try {
    var pages = await storyblokApi.getAll("cdn/links", {
      version: "published",
      with_parent: "0",
      cv: "undefined",
    });
  } catch (e) {
    console.error(e);
    return {
      paths: [],
      fallback: "blocking",
    };
  }

  const paths = [];
  pages.forEach(({ is_folder, slug }) => {
    if (is_folder || slug === "home") {
      return;
    }

    paths.push({ params: { slug: slug.split("/") } });
  });

  return {
    paths: paths,
    fallback: "blocking",
  };
}
